module.exports = __webpack_public_path__ + "img/0050.b114e5c6.png";